import { User } from "oidc-client-ts"

let socket;

function getUser() {
    const authority = process.env.REACT_APP_COGNITO_AWS_AUTHORITY
    const client_id = process.env.REACT_APP_COGNITO_AWS_CLIENT_ID
    const oidcStorage = sessionStorage.getItem(`oidc.user:${authority}:${client_id}`)
    if (!oidcStorage) {
        return null;
    }
    return User.fromStorageString(oidcStorage);
}

export default function initiate_socket_connect(params) {

    const user = getUser();
    const idToken = user?.id_token;
    const payloadObj = {
        ...params,
        token: idToken
    };

    const queryParams = Object.entries(payloadObj)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');

    const apiSocketUrl = process.env.REACT_APP_API_SOCKET_URL;    

    socket = new WebSocket(`${apiSocketUrl}?${queryParams}`);
    
}

export function getSocket() {
    return socket;
}
